import { X } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const NotRightSection = () => {
  const limitations = [
    "If you're hiring more than 2 people per month",
    "If you are hiring at salary ranges above ₹35LPA",
    "If you need ATS integrations or recruiter analytics",
    "If your team has more than 5 recruiters"
  ];

  const comparisonData = [
    {
      feature: "Tech Profile Unlock Limit",
      starter: "25",
      enterprise: "250 / Custom"
    },
    {
      feature: "Salary Limit (Tech)",
      starter: "₹35L",
      enterprise: "Unlimited"
    },
    {
      feature: "ATS Integrations",
      starter: "No",
      enterprise: "Yes (7+ / 50+)"
    },
    {
      feature: "Support",
      starter: "Email only",
      enterprise: "Chat / Phone + Onboarding"
    },
    {
      feature: "DPA / Legal",
      starter: "Not included",
      enterprise: "Included"
    },
    {
      feature: "Analytics",
      starter: "Basic",
      enterprise: "Standard / Per recruiter"
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-8">
              When the Starter Plan is not the right plan for you
            </h2>
          </div>

          <div className="mb-12">
            <div className="grid md:grid-cols-2 gap-4">
              {limitations.map((limitation, index) => (
                <div key={index} className="flex items-start gap-3 p-4 bg-red-50 rounded-lg border border-red-200">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                  <p className="text-foreground font-medium">{limitation}</p>
                </div>
              ))}
            </div>
          </div>

          <Card className="overflow-hidden mb-8">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-border bg-muted">
                    <th className="text-left py-4 px-6 font-semibold text-foreground">Feature</th>
                    <th className="text-center py-4 px-6 font-semibold text-foreground">Starter Plan</th>
                    <th className="text-center py-4 px-6 font-semibold text-foreground">Standard/Enterprise</th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonData.map((row, index) => (
                    <tr key={index} className="border-b border-border last:border-b-0">
                      <td className="py-4 px-6 font-medium text-foreground">{row.feature}</td>
                      <td className="py-4 px-6 text-center text-muted-foreground">{row.starter}</td>
                      <td className="py-4 px-6 text-center font-medium text-primary">{row.enterprise}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>

          <div className="text-center">
            <a href="http://cutshort.io/pricing" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" size="lg" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground">
                Explore our Standard and Enterprise Plans instead
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotRightSection;


